
import Tab from '@/components/Tab/Tab'
import dateFormat from 'vux/src/tools/date/format.js'
import TabItem from 'vux/src/components/tab/tab-item.vue'

import Guide from '@/components/Guide/Guide'
import XShot from '@/components/XShot/XShot'
import { videoPlayer } from 'vue-video-player'
import HeaderBar from '@/components/HeaderBar/HeaderBar'
import CountDown from '@/components/CountDown/CountDown'
import YpTitle from '@/components/Title/Title'
import Scroller from '@/components/Scroller/Scroller'
import Tips from '@/components/Tips/Tips'
import AdBar from '@/components/AdBar/AdBar'
import Loading from '@/components/Loading/Loading'
import FaceRecog from '@/components/FaceRecog/FaceRecog'
import WechatShare from '@/components/WechatShare/WechatShare'
import InfiniteScroller from '@/components/InfiniteScroller/InfiniteScroller'
import PassView from '@/components/PassView/PassView'
import * as types from '../../store/mutation-types.js'
import Previewer from '@/components/Previewer/Previewer'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'

import base64 from 'vux/src/tools/base64/index.js'

import api from '../../api/api'
require('videojs-contrib-hls/dist/videojs-contrib-hls')
require('videojs-flash')
export default {
directives: {
TransferDom
},
data() {
return {
isFixed: false,
showDetail: false,
pageSize: 50,
category: [],
tab_index: 0,
videoUrl: '',
message_pic: 0,
categoryId: 0,
viewCount: 0,
showSticky: true,
isVisited: false,
pageData: [],
hideAll: false,
isShowLoading: true,
loop: false,
isLoad: true,
shotArr: [],
options: {
bgOpacity: 0.9,
loop: false,
clickToCloseNonZoomable: false,
tapToClose: false,
errorMsg:
'<div class="pswp__error-msg">哎呀，图片加载不出来了...</div>',
isClickableElement: function(el) {
if (
navigator.userAgent.indexOf('Android') > -1 ||
navigator.userAgent.indexOf('Adr') > -1
) {
return true
} else {
return false
}
}
}
}
},
computed: {
showCountDown() {
var now = new Date().getTime()
var begin = new Date(this.live.BeginAt).getTime()
if (now > begin) {
return false
} else {
return true
}
},
locationUrl() {
return window.location.href
},
showPass() {
if (this.live.EncryptEnabled) {
let time = new Date(window.localStorage[this.live.Id])
if (time) {
let now = new Date()
if (now.getTime() - time.getTime() < 24 * 60 * 60 * 1000) {
return false
} else {
window.localStorage.removeItem(this.live.Id)
return true
}
} else {
return true
}
} else {
return false
}
},
player() {
return this.$refs.videoPlayer.player
},
playerOptions() {
return {
muted: false,
// videojs and plugin options
sources: [
{
withCredentials: false,
type: 'application/x-mpegURL',
src: this.videoUrl
}
],
errorDisplay: false,
height: 200,
flash: { hls: { withCredentials: false } },
html5: { hls: { withCredentials: false } },
poster: this.live.Banner
}
},
player2Options() {
return {
// videojs and plugin options
muted: false,
language: 'en',
playbackRates: [0.7, 1.0, 1.5, 2.0],
errorDisplay: false,
sources: [
{
type: 'video/mp4',
src: this.live.BannerVideo
}
],
controlBar: {
timeDivider: false,
durationDisplay: false,
captionsButton: false,
chaptersButton: false
},
height: 200,
poster: this.live.Banner
}
},
showOrder() {
return this.live.ParticipatorDisabled
},
showInteract() {
return this.live.InteractDisabled
},
viewHeight() {
return this.$store.state.base.viewHeight
},
pageIndex() {
return this.$store.state.live.pageIndex
},
picCount() {
return this.$store.state.live.detail.PublishPicturesCount
},
live() {
return this.$store.state.live.detail
},
photoList() {
if (this.$store.state.live.photoList) {
// 判断是否加载完毕
if (
this.$store.state.live.totalNum ==
this.$store.state.live.photoList.length
) {
this.isLoad = false
} else {
this.isLoad = true
}
return this.$store.state.live.photoList
}
},
previewerList() {
return this.initPreviewPhotoList(this.photoList)
},
copyRightDisplay() {
return this.$store.state.live.detail.CopyrightDisplay
}
},
components: {
Popup,
Guide,
HeaderBar,
YpTitle,
Scroller,
Tips,
InfiniteScroller,
AdBar,
Loading,
WechatShare,
Previewer,
Tab,
PassView,
TabItem,
FaceRecog,
videoPlayer,
CountDown,
XShot
},
beforeRouteEnter(to, from, next) {
next(vm => {
if (to.name == 'liveDetail' && from.name == 'liveInteraction') {
vm.isShowLoading = false
}
vm.fetchLiveDetail()
})
},
beforeRouteLeave(to, from, next) {
// 导航离开该组件的对应路由时调用
// 可以访问组件实例 `this`
window.removeEventListener('scroll', this.video_fix, false)
window.removeEventListener('scroll', this.fn_scroll, false)

next()
},
methods: {
description(text) {
if (text) {
return text.replace('\r\n', '<br/>')
} else {
return ''
}
},
goHotView() {
this.$vux.loading.show({
text: '生成看点...'
})
this.$router.push({
name: 'hotView'
})
},
fresh_pic() {
this.fetchData('all')
// 切换到第一个
this.tab_index = 0
this.message_pic = 0
},
/** 添加照片 */
addPicture(url, pId) {
// 查询单个照片信息并插入
api.live.getPhotoDetail(pId).then(item => {
// 插入首页数组首位
this.photoList.splice(0, 0, item)
})
},
/** 监听发布图片更新 */
socketPushPhoto() {
const _this = this
const liveId = this.live.Id
const domain =
window.location.hostname == 'yun.aiyaopai.com'
? 'yunfront.aiyaopai.com'
: 'yunfront.aiyaopai.com'
// 初始化
const websocket = new WebSocket(
`wss://${domain}/ws/publishpicture?activityid=${liveId}`
)

websocket.onopen = function(evt) {
// 每隔10s发送心跳包
setInterval(() => {
websocket.send('yaopaiLive')
}, 10000)
}
websocket.onmessage = function(evt) {
let obj = JSON.parse(evt.data)
if (obj.Action == 'Inserted') {
let url = obj.Url
let picId = obj.Id
// _this.addPicture(url, picId)
_this.message_pic++
}
}
websocket.onclose = function(evt) {
console.log('onclose', evt)
}
websocket.onerror = function(evt) {
console.log('onerror', evt)
}
},
shotClose() {
this.$refs.infinite_scroller.checkCancel()
},
startShot(arr) {
this.$refs.x_shot.init(arr, this.live.Id)
},
cancelShot() {
// this.$refs.infinite_scroller.toggleMode()
this.hideAll = !this.hideAll
},
// 选择要截图的内容
choseShot() {
// 让所有图片进入可选状态
this.$refs.infinite_scroller.toggleMode()
// this.closeVideo()
this.hideAll = !this.hideAll
// alert(this.live.FaceEnabled && !this.hideAll)
},
initLoading() {
// 判断是否有loadingTime字段
let time = window.localStorage.getItem('loadingTime')
let now = new Date()
if (time) {
// 计算时间是否超时24h
// console.log('=========', now.getTime(), new Date(time).getTime())
if (now.getTime() - new Date(time).getTime() > 24 * 60 * 60 * 1000) {
// 设置loading页面显示
this.isShowLoading = true
// 再次初始值
window.localStorage.setItem('loadingTime', now)
} else {
// 不显示
this.isShowLoading = false
}
} else {
window.localStorage.setItem('loadingTime', now)
// console.log('初次保存', window.localStorage.getItem('loadingTime'))
}
},
playerReadied(player) {
var hls = player.tech({ IWillNotUseThisInPlugins: true }).hls
player.tech_.hls.xhr.beforeRequest = function(options) {
// console.log(options)
return options
}
},
fetchData(categoryId) {
this.shotClose()
this.hideAll = false
this.$vux.loading.show({
text: '加载中...'
})
// 滚动页面到固定位置
window.scrollTo(0, document.getElementById('pic_live').offsetTop + 40)
this.categoryId = categoryId
if (categoryId == 'all') {
this.$store.commit({
type: types.live.setPageIndex,
index: 1
})
// 查询全部的逻辑
this.fetchLivePhotoList(this.pageIndex, null)
} else {
// 查询当前数据
this.$store.commit({
type: types.live.setPageIndex,
index: 1
})
this.fetchLivePhotoList(this.pageIndex, categoryId)
}
},
fetchCategory() {
let liveId = this.$route.params.liveId
api.live.fetchCategory(liveId).then(res => {
if (res && res.length > 0) {
if (document.getElementById('sticky-bar')) {
document.getElementById('sticky-bar').style.width =
res.length * 100 + 'px'
}
this.category = res
} else {
this.showSticky = false
}
})
},
order() {
window.location.href =
window.location.origin +
'/static/invite/index.html?id=' +
this.$route.params.liveId
},
// 初始化预览图列表
initPreviewPhotoList(list) {
// 构建一个新previewer数组
let preview_arr = []
if (list) {
list.map((item, index) => {
let url = ''
let originUrl = this.initOriginPic(item)

if (this.copyRightDisplay) {
url = this.initCopyrightQiniu(item)
} else {
url = this.initPreviewQiniu(item)
}
preview_arr.push({
info: item,
src: url,
isOrigin: false,
w: item.Width,
h: item.Height,
origin_url: originUrl
})
})
}
return preview_arr
},
closeVideo() {
this.isFixed = false
window.removeEventListener('scroll', this.video_fix, false)
document.getElementsByClassName('video-js')[0].style.height = '200px'
},
initOriginPic(live) {
let new_url = ''
if (live) {
let img_watermark = base64.encode(
this.$store.state.live.detail.Watermark || ''
)
let encodeUrl
if (this.copyRightDisplay) {
encodeUrl = encodeURIComponent(
`watermark/3/text/wqlZQU9QQUk=/font/5b6u6L2v6ZuF6buR/fontsize/800/fill/I0ZGRkZGRg==/dissolve/85/gravity/SouthWest/dx/20/dy/20/image/${img_watermark}/dissolve/90/gravity/SouthEast`
)
} else {
encodeUrl = encodeURIComponent(
`watermark/1/image/${img_watermark}/dissolve/90/gravity/SouthEast`
)
}
new_url = `${live.Url}?${encodeUrl}`
}
return new_url
},

// 拼接版权水印
initCopyrightQiniu(live) {
let new_url = ''
if (live) {
// 获取水印
let img_watermark = base64.encode(
this.$store.state.live.detail.Watermark
)
// 返回添加水印并裁剪尺寸为1000*1000的图
let encodeUrl
encodeUrl = encodeURIComponent(
`imageslim|watermark/3/text/wqlZQU9QQUk=/font/5b6u6L2v6ZuF6buR/fontsize/500/fill/I0ZGRkZGRg==/dissolve/85/gravity/SouthWest/dx/20/dy/20/image/${img_watermark}/dissolve/90/gravity/SouthEast`
)
new_url = `${live.Url}?${encodeUrl}`
}
return new_url
},

// 拼接预览图（七牛水印+500*500裁剪参数）
initPreviewQiniu(live) {
// 获取base64转码后的水印图

let watermark = base64.encode(this.$store.state.live.detail.Watermark)
// 返回添加水印并裁剪尺寸为1000*1000的图
let encodeUrl
encodeUrl = encodeURIComponent(
`imageslim|watermark/1/image/${watermark}/dissolve/90/gravity/SouthEast`
)
let url = `${live.Url}?${encodeUrl}`
return url
},
getViewCount(id) {
api.live.addViewCount(id).then(count => {
this.viewCount = count.Result
})
},
fetchLiveDetail() {
this.$store
.dispatch({
type: 'getLiveDetail',
liveId: this.$route.params.liveId,
router: this.$router
})
.then(() => {
document.title = this.live.Title
// 监听数据变化
this.socketPushPhoto()
this.$refs.wechat.fetch()
// 获取浏览量
this.getViewCount(this.live.Id)
if (this.live.LiveEnabled) {
// 获取当前视频地址
api.live
.getLivePushUrl(this.live.LivePullStreamUrl)
.then(res => {
// 设置当前视频路径
console.log('=======',res.data.Result)
this.videoUrl = res.data.Result
})
.catch(err => {
console.log(err)
})
}
})
},
video_fix() {
// 视频播放器滚动直播
if (this.live.LiveEnabled || this.live.BannerVideo) {
if (window.scrollY >= 250 && !this.hideAll) {
this.isFixed = true
document.getElementsByClassName('video-js')[0].style.height = '140px'
} else {
this.isFixed = false
document.getElementsByClassName('video-js')[0].style.height = '200px'
}
}
},

fn_scroll() {
if (document.getElementById('header')) {
if (window.scrollY >= document.documentElement.clientHeight) {
document.getElementById('header').style.opacity = '0'
} else {
document.getElementById('header').style.opacity = '1'
}
}
if (this.showSticky) {
var top = document.getElementById('pic_live').offsetTop
if (window.scrollY >= top + 40) {
if (document.getElementById('sticky-bar')) {
document.getElementById('sticky-box').style.position = 'fixed'
document.getElementById('sticky-copy').style.display = 'block'
}
} else {
if (document.getElementById('sticky-bar')) {
document.getElementById('sticky-box').style.position = 'relative'
document.getElementById('sticky-copy').style.display = 'none'
}
}
}
},
fetchLivePhotoList(index, categoryId) {
let options = {}
if (categoryId) {
options = {
categoryId: categoryId,
liveId: this.$route.params.liveId,
pageIndex: index,
pageSize: this.pageSize
}
} else {
options = {
liveId: this.$route.params.liveId,
pageIndex: index,
pageSize: this.pageSize
}
}
this.$store.dispatch({
type: 'getPhotoList',
option: options
})
},

showLiveDesc() {
this.showDetail = true
},
show(index) {
this.$refs.previewer.show(index)
},
loadMore() {
this.$store.commit({
type: types.live.setPageIndex,
index: ++this.pageIndex
})
// 加载数据
if (this.categoryId == 'all') {
this.fetchLivePhotoList(this.pageIndex, null)
} else {
this.fetchLivePhotoList(this.pageIndex, this.categoryId)
}
}
},

mounted() {
// 判断用户是否第一次加载
if (window.localStorage.visited) {
if (JSON.parse(window.localStorage.visited)) {
this.isVisited = true
}
}
// 初始化loading页面
// this.initLoading()
// 加载分类
this.fetchCategory()
// 加载图片列表
if (this.$store.state.live.photoList.length == 0) {
this.fetchLivePhotoList(this.pageIndex, null)
}

window.addEventListener('scroll', this.video_fix, false)
window.addEventListener('scroll', this.fn_scroll, false)
}
}



// WEBPACK FOOTER //
// ./src/pages/live/LiveDetail.vue